const antiPassback = {
  title: 'Anti-passback',
  restriction_mode: {
    title: 'Restriction Mode',
    hard: 'Hard',
    soft: 'Soft',
    hard_helper: 'Denies access when a passback violation is detected',
    soft_helper: 'Logs the passback violation but still grants access',
  },
  user_exit_reset: {
    title: 'User Exit Reset',
    delay_or_exit_reader: {
      title: 'Delay or Exit reader',
      description:
        'Reset on peripheral reader presentation, or automatically after a delay period.',
    },
    schedule_or_exit_reader: {
      title: 'Schedule or Exit reader',
      description:
        'Reset on peripheral reader presentation, or at scheduled times.',
      info: 'Reset occurs at the start of the schedule.',
    },
    exit_reader_only: {
      title: 'Exit reader ONLY',
      description:
        'User location resets only when the credential is presented at a peripheral reader.',
      warning: 'Select at least one door with an exit reader.',
    },
  },
  exempted_users: {
    title: 'Exempted users',
    description: 'Selected users are exempt from Anti-passback enforcement.',
  },
  peripheral_doors: {
    title: 'Peripheral doors',
    description:
      'Selected doors will enforce the Anti-passback setting when enabled.',
  },
  validation: {
    must_be_number: 'Must be a number',
    must_be_integer: 'Must be an integer',
    must_be_at_least: 'Must be at least {{min}}',
    must_be_at_most: 'Must be at most {{max}}',
  },
  not_supported: {
    title: 'Feature not supported',
    description:
      'The main controller firmware version must be {{ minVersion }} or higher to use the Anti-passback feature. Update the main controller firmware to access this feature.',
  },
  firmware_requirement: 'Firmware requirement',
};

export default antiPassback;
